import React from 'react';

import SeaticsMapWidget from '../features/SeaticsMapWidget';

import data from './FeatureSeatics.data.json';

const currentEvent = {
  eventId: '3254457',
};


const ticketList = Object.keys(data.Recommended).map(key => ({...data.Recommended[key], curatedTitle: key}));

class FeatureSeatics extends React.PureComponent {
  render() {
    return (
      <div style={{ marginBottom: 32 }}>
        <SeaticsMapWidget
          {...currentEvent}
          {...this.props}
          ticketList={ticketList}
        />
      </div>
    );
  }
}

export default FeatureSeatics;



// WEBPACK FOOTER //
// ./src/components/demo/FeatureSeatics.js